import { JobOptionSvcGroup } from 'domains/jobconfigDomain';
import { useMemo } from 'react';
import {
  BundlingRenderTypeEnum,
  useSvcBundlingList,
} from './useSvcBundlingList';
import { useSvcGroupTitle } from './useSvcGroupTitle';

interface Iprops {
  svcGroup?: JobOptionSvcGroup;
}

export const useSvcBundling = (props: Iprops) => {
  const { svcGroup } = props;
  const svcBundlingList = useSvcBundlingList();

  const svcName = useSvcGroupTitle({ svcGroup });

  const hasBundling = useMemo(() => {
    const hasBundlingSvc = svcBundlingList.find((item) => {
      return Boolean(
        svcGroup?.svcs?.find((job) => {
          return (
            job.typeName === item.typeName && job.revxTypeId === item.revxTypeId
          );
        })
      );
    });
    if (hasBundlingSvc) {
      return hasBundlingSvc;
    } else {
      return {
        revxTypeId: svcGroup?.svcs?.[0].id,
        typeName: svcGroup?.svcs?.[0].typeName,
        renderType: BundlingRenderTypeEnum.DEFAULT,
        text: svcName,
      };
    }
  }, [svcGroup, svcBundlingList, svcName]);

  return hasBundling;
};
